module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf@2-20309d14a3674cdb0604a49f9431984a.jpg";